import React, { useState, useEffect } from 'react';
import '../../css/slider.css';
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';
import { FaArrowRightLong } from "react-icons/fa6";
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import { Swiper, SwiperSlide } from 'swiper/react';
import PlaceholderLoading from 'react-placeholder-loading';
import ImgDecatlonSvg from '../../assets/svg/iconLogoDecatlhon.svg';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

const Slider = (props) => {
    
    
    const {
        listRespData,
        getImage,
    } = props;
    
    const navigate = useNavigate();
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const [swiperIndexFirst, setSwiperIndexFirst] = useState(0);
    const [swiperInstanceFirst, setSwiperInstanceFirst] = useState(null)
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const delay = setTimeout(() => {
        setIsLoading(false); 
        }, 1000); 

        return () => clearTimeout(delay); 
    }, []);

    const hadleBtnClickSearchPartners = (item) => {
        let seacrhCategory = item.storeName
        navigate("/ganhar-saldo/parceiros/catalogo-de-parceiros", { state: { seacrhCategory} });
    };

    const handleSwiperSlideChangeFirst = (swiperFirst) => {
        setSwiperIndexFirst(swiperFirst.activeIndex);
    };

    const nextImageFirst = () => {
        if (swiperInstanceFirst !== null) {
            swiperInstanceFirst.slideNext();
        }
    };

    const prevImageFirst = () => {
        if (swiperInstanceFirst !== null) {
            swiperInstanceFirst.slidePrev();
        }
    };

    const renderImageByItem = (item) => {
        const imageAdsNum =  getImage(item.imageUrl);
        return imageAdsNum;
    };

  return (
    <>

        <Swiper
            onSlideChange={(swiper) => handleSwiperSlideChangeFirst(swiper)}
            onSwiper={(swiper) => setSwiperInstanceFirst(swiper)}
            slidesPerView={1}
            centeredSlides={true}
            autoplay={{
                delay: 5000,
                disableOnInteraction: false,
            }}
            // pagination={{
            // clickable: true,
            // }}
            navigation={false}
            modules={[Autoplay, Pagination, Navigation]}
            className={ isTablet ? "mySwiperSlider" : "mySwiperSliderMobile"}
            >
            {listRespData.map((item, index) => (
            <SwiperSlide  key={index} >
                { isTablet ? (
                <>
                <div onClick={() => hadleBtnClickSearchPartners(item)} className='secondSubMainContainerSlider'>
                { isLoading ? <PlaceholderLoading shape="rect" width={350} height={175}/> : (
                    <>
                    <div className='imgAdsMainViewSlider' style={{ backgroundImage: `url(${renderImageByItem(item)?.img?.desktop})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                        {/* <img src={item.imageUrl} alt="imagem"  className='imgAdsSlider' /> */}
                        <div className='adsProductStatusViewSlider'>
                            <div className='txtAdsProductStatusSlider'>{item.productStatus}</div>
                        </div>
                    </div>
                    <div className='txtAdsMainViewSlider'>
                        <div className='txtAdsMainTitleViewSlider'>
                            <div className='txtAdsDateSlider'>{item.categoryType}</div>
                        </div>
                        <div className='txtAdsMainTitleViewSlider'>
                            <div className='txtAdsBoldSlider'>{item.title}</div>
                        </div>
                        <div className='txtAdsMainSubTitleViewSlider'>
                            <div className='txtAdsRegularSlider'>{item.description}</div>
                        </div>
                        <div className='imgAdsCompanyLogoMainViewSlider'>
                            <img src={renderImageByItem(item)?.logo} alt="imagem" className='imgAdsCompanyLogoSlider' />
                            <div className='txtAdsCompanyLogoViewSlider'>
                                <div className='txtAdsCompanyTitleSlider'>{item.storeName}</div>
                                {/* <div className='txtAdsProductCategoryTitleSlider'>{item.productCategory}</div> */}
                            </div>
                        </div>
                    </div>
                    </>
                )}
                </div>
                
                {/* <div className='boxMainShadowFirstViewContainerBottomViewContainerSlider'>
                    <div className='boxShadowFirstViewContainerBottomViewContainerSlider'></div>
                </div>
                <div className='boxMainShadowFirstViewContainerBottomViewContainerSlider'>
                    <div className='boxShadowSecondViewContainerBottomViewContainerSlider'></div>
                </div> */}
                
                
                </>
                ) : ( isMobile ? (
                    <div className='secondSubMainContainerSliderTablet'>
                    { isLoading ? <PlaceholderLoading shape="rect" width={350} height={175}/> : (
                        <>
                        <div className='imgAdsMainViewSliderTablet'>
                            <div className='imgAdsMainWithImgViewSliderTablet' style={{ backgroundImage: `url(${renderImageByItem(item)?.img?.tablet})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                            {/* <img src={item.imageUrl} alt="imagem"  className='imgAdsSlider' /> */}
                                <div className='adsProductStatusViewSliderTablet'>
                                    <div className='txtAdsProductStatusSlider'>{item.productStatus}</div>
                                </div>
                            </div>
            
                            <div className='txtAdsMainViewSliderTablet'>
                                <div className='txtAdsMainTitleViewSlider'>
                                    <div className='txtAdsDateSliderTablet'>{item.categoryType}</div>
                                </div>
                                <div className='txtAdsMainTitleViewSlider'>
                                    <div className='txtAdsBoldSliderTablet'>{item.title}</div>
                                </div>
                                <div className='txtAdsMainSubTitleViewSlider'>
                                    <div className='txtAdsRegularSliderTablet'>{item.description}</div>
                                </div>
                                <div className='imgAdsCompanyLogoMainViewSliderTablet'>
                                    <img src={renderImageByItem(item)?.logo} alt="imagem" className='imgAdsCompanyLogoSlider' />
                                    <div className='txtAdsCompanyLogoViewSlider'>
                                        <div className='txtAdsCompanyTitleSlider'>{item.storeName}</div>
                                        {/* <div className='txtAdsProductCategoryTitleSlider'>{item.productCategory}</div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        </>
                    )}
                    </div>
                ) : (
                    <div className='secondSubMainContainerSliderMobile'>
                    { isLoading ? <PlaceholderLoading shape="rect" width={350} height={175}/> : (
                        <>
                        <div className='imgAdsMainViewSliderMobile' style={{ backgroundImage: `url(${renderImageByItem(item)?.img?.mobile})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                            {/* <img src={item.imageUrl} alt="imagem"  className='imgAdsSlider' /> */}
                            <div className='adsProductStatusViewSliderMobile'>
                                <div className='txtAdsProductStatusSlider'>{item.productStatus}</div>
                            </div>
            
                            <div className='txtAdsMainViewSliderMobile'>
                                <div className='txtAdsMainTitleViewSlider'>
                                    <div className='txtAdsDateSliderMobile'>{item.categoryType}</div>
                                </div>
                                <div className='txtAdsMainTitleViewSlider'>
                                    <div className='txtAdsBoldSliderMobile'>{item.title}</div>
                                </div>
                                <div className='txtAdsMainSubTitleViewSlider'>
                                    <div className='txtAdsRegularSliderMobile'>{item.description}</div>
                                </div>
                                <div className='imgAdsCompanyLogoMainViewSliderMobile'>
                                    <img src={renderImageByItem(item)?.logo} alt="imagem" className='imgAdsCompanyLogoSlider' />
                                    <div className='txtAdsCompanyLogoViewSliderMobile'>
                                        <div className='txtAdsBoldSliderMobile'>{item.storeName}</div>
                                        <div className='txtAdsDateSliderMobile'>{item.productCategory}</div>
                                        {/* <div className='txtAdsProductCategoryTitleSlider'>{item.productCategory}</div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        </>
                    )}
                    </div>
                ))}
            </SwiperSlide>
            ))} 
        </Swiper>

        <div className={isTablet ? 'thirdSubMainContainerCircleNavSlider' : (isMobile ? 'thirdSubMainContainerSliderTablet' : 'thirdSubMainContainerSliderMobile')}>
            <button className='iconArrowLeftViewContainerSlider' onClick={prevImageFirst} disabled={swiperIndexFirst == 0}>
                <FaArrowLeftLong className='iconArrowSlider' />
            </button>

            <div className='cirlceSelectedSlider'>
                <div className='circleMainvViewSlider'>
                    <div className='circleContainerSlider'>
                        <div className={swiperIndexFirst == 0 ? 'circleSelectedViewSlider' : 'circleViewSlider'} />
                    </div>
                    <div className='circleContainerSlider'>
                        <div className={swiperIndexFirst == 1 ? 'circleSelectedViewSlider' : 'circleViewSlider'} />
                    </div>
                    <div className='circleContainerSlider'>
                        <div className={swiperIndexFirst >= 2 ? 'circleSelectedViewSlider' : 'circleViewSlider'} />
                    </div>
                </div>
            </div>

            <button className='iconArrowRightViewContainerSlider' onClick={nextImageFirst} disabled={swiperIndexFirst >= listRespData.length - 1}>
                <FaArrowRightLong className='iconArrowSlider' />
            </button>
        </div>

    </>
  )
}

export default Slider;